import PropTypes from 'prop-types';
import React, { useCallback, memo, useMemo } from 'react';
import _ from 'underscore';
import { LineByLineFormGroup } from '@bingads-webui-cc-react/layout';
import { Select } from '@bingads-webui-react/primitive-with-signal';
import { PiOptionNames } from '../constants';
import { i18nPropType } from '../shapes';

export const PaymentTypeInputUnMemo = ({
  i18n,
  setPaymentType,
  paymentType,
  paymentTypeOptions,
  disabled,
}) => {
  const paymentTypeOptionsWithValues = useMemo(
    () => _.map(
      paymentTypeOptions,
      paymentTypeId => ({
        id: paymentTypeId,
        value: i18n.getString(PiOptionNames[paymentTypeId]),
      })
    ),
    [i18n, paymentTypeOptions]
  );

  const selectOptions = useMemo(
    () => paymentTypeOptionsWithValues.map(({ id, value }) => <option key={id} value={id}>{value}</option>),
    [paymentTypeOptionsWithValues]
  );

  return (
    <LineByLineFormGroup
      label={i18n.getString(_TL_('Choose a payment setting'))}
      helpPopupTopic="Pop_BA_PaymentMethods_Index_PaymentSetting"
      // This prop isn't supported by LineByLineFormGroup or the help popup element.
      // We need to see if it's actually needed for anything, and add it if so
      // helpPopupId="AccountPaymentTypesHelp"
      helpPopupAriaLabel={i18n.getString(_TL_('Payment settings tooltip'))}
    >
      <Select
        name="pi payment option type selection"
        value={paymentType}
        aria-label={i18n.getString(_TL_('Payment settings dropdown'))}
        onChange={useCallback(
          ({
            target: { value: newValue },
          }) => setPaymentType(Number(newValue)),
          [setPaymentType]
        )}
        disabled={disabled}
      >
        {selectOptions}
      </Select>
    </LineByLineFormGroup>
  );
};

PaymentTypeInputUnMemo.displayName = 'PaymentTypeInput';
PaymentTypeInputUnMemo.propTypes = {
  i18n: i18nPropType.isRequired,
  setPaymentType: PropTypes.func.isRequired,
  paymentType: PropTypes.number.isRequired,
  paymentTypeOptions: PropTypes.arrayOf(PropTypes.number).isRequired,
  disabled: PropTypes.bool,
};

PaymentTypeInputUnMemo.defaultProps = {
  disabled: false,
};

export const PaymentTypeInput = memo(PaymentTypeInputUnMemo);
